import { define } from '@owenscorning/pcb.alpha';
import { useEffect } from 'react';

import { wrapRef } from '../../../../data';

export default define`Data Reference`('0.0.1')({
  view: <div />,
  edit: ({ type, dataset, parameters, onChange, value }) => {
    useEffect(() => {
      onChange(
        wrapRef('Cms::DataProvider', {
          type,
          dataset,
          parameters: parameters?.[dataset] ?? {},
        })
      );
    }, [type, dataset, JSON.stringify(parameters || {})]);
    return null;
  },
});
